// eslint-disable-next-line import/no-duplicates
import type React from 'react';
// eslint-disable-next-line import/no-duplicates
import { useState, useCallback } from 'react';
import { IconSearch, TextField } from 'braid-design-system';
import { events, link } from 'src/modules/analyticsTracker';

import { useTranslations } from '@vocab/react';
import translations from './.vocab';

interface Props {
  onChange: (value: string) => void;
}

const BrandSearchInput = ({ onChange }: Props) => {
  const [value, setValue] = useState('');

  const onBlurCallback = useCallback(() => link(events.BRANDS_SEARCHED), []);

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  const { t } = useTranslations(translations);

  return (
    <TextField
      id="brandSearch"
      aria-label="Brand search"
      placeholder={t('Search your brands')}
      icon={<IconSearch />}
      value={value}
      onChange={onTextChange}
      onBlur={onBlurCallback}
    />
  );
};

export default BrandSearchInput;
